import store from '@/state/store';
import projectSlice from '@/state/project.slice';
import authenticationSlice from '@/state/authentication.slice';
import { Event, Profile } from '@bimdata/definitions/dto';
import { get as getProject } from '@/api/project';
import participantsLoader from '@/loaders/project/participants.loader';

export default async function (event: Event, profile: Profile) {
  const { projectCode, userId, invitationId } = event.data;
  if (userId === profile.id) {
    store.dispatch(authenticationSlice.actions.removeInvitation(invitationId));
    let project = null;
    try {
      project = await getProject(projectCode);
    } catch (error) {
      if (error.code !== 404) {
        throw error;
      }
    }
    if (project) {
      store.dispatch(projectSlice.actions.created(project));
    }
  } else {
    store.dispatch(projectSlice.actions.removeInvitations({
      code: projectCode,
      ids: [invitationId]
    }));
    await participantsLoader(projectCode);
  }
};
